import { useHistory } from 'react-router-dom'
import { useUser } from '@paintscout/ui-business'

export function useSherwinTrialOverDashboard() {
  const history = useHistory()
  const { isAdmin } = useUser()

  const handleSelectPlan = () => {
    history.push('/settings?section=billing-plan')
  }

  return {
    isAdmin,
    handleSelectPlan
  }
}
